import { RestClient } from '@libs/rest-client';
import {
  hoMstDelete,
  hoMstExport,
  hoMstFetch,
  hoMstImport,
  hoMstListRequest,
  hoMstRegistration,
  hoMstUpdate,
} from '@libs/templates/mst';
import {
  SegmentMstListSearchRaw,
  SegmentMstRegistration,
  SegmentMstRegistrationRaw,
  SegmentMstSetting,
  SegmentMstSettingRaw,
} from '../models';

const SEGMENT_MST_URL = '/segment-mst';

const segmentMstUrlByKey = (segmentMstKey: number) =>
  SEGMENT_MST_URL + segmentMstKey.toString().padStart(2, '0');

const register = (segmentMstKey: number) =>
  hoMstRegistration(segmentMstUrlByKey(segmentMstKey), SegmentMstRegistrationRaw);

const listRequest = (segmentMstKey: number) =>
  hoMstListRequest(segmentMstUrlByKey(segmentMstKey), SegmentMstListSearchRaw, SegmentMstRegistration);

const doExport = (segmentMstKey: number) =>
  hoMstExport(segmentMstUrlByKey(segmentMstKey), SegmentMstListSearchRaw);

const fetchMst = (segmentMstKey: number) =>
  hoMstFetch(segmentMstUrlByKey(segmentMstKey), SegmentMstRegistration);

const update = (segmentMstKey: number) =>
  hoMstUpdate(segmentMstUrlByKey(segmentMstKey), SegmentMstRegistrationRaw);

const remove = (segmentMstKey: number) => hoMstDelete(segmentMstUrlByKey(segmentMstKey));

const importFunction = (segmentMstKey: number) => hoMstImport(segmentMstUrlByKey(segmentMstKey));

async function fetchSegmentMstSettings() {
  return (await RestClient.fa.get<SegmentMstSettingRaw[]>(`${SEGMENT_MST_URL}/setting`)).map(
    SegmentMstSetting.fromRaw,
  );
}

async function registerSettings(settings: SegmentMstSetting[], defaultNames: string[]) {
  await RestClient.fa.put(
    `${SEGMENT_MST_URL}/setting`,
    settings.map((s, i) => SegmentMstSettingRaw.fromModel(s, defaultNames[i])),
  );
}

export {
  doExport,
  fetchMst,
  fetchSegmentMstSettings,
  importFunction,
  listRequest,
  register,
  registerSettings,
  remove,
  update,
};
